// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"1ad25dc3","181":"97a33f3d","376":"34352c4a","474":"dcb72537","709":"90306a27"}[chunkId] + ".chunk.js";
};